module.exports = __webpack_public_path__ + "static/media/1200x1200bf-60-1-394x394.32584cea.jpg";